// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { compose } from 'redux';
import AddMailingAddressReducer from '@tcp/core/src/components/features/account/MyProfile/organism/MailingInformation/container/MailingAddress.reducer';
import MailingAddressSaga from '@tcp/core/src/components/features/account/MyProfile/organism/MailingInformation/container/MailingAddress.saga';
import MyPrefrence from '../views';

const getMyPrefrenceLabels = (labels) => {
  return (labels && labels.preferences) || {};
};

const getCommonTestLabels = (labels) => {
  return (labels && labels.common_test) || {};
};

export class MyPrefrenceContainer extends PureComponent {
  render() {
    const { labels, handleComponentChange, componentProps, router } = this.props;
    const urlParams = router.query || {};
    const myPrefrenceLabels = getMyPrefrenceLabels(labels);
    const myCommonTestLabels = getCommonTestLabels(labels);

    return (
      <MyPrefrence
        labels={myPrefrenceLabels}
        handleComponentChange={handleComponentChange}
        componentProps={componentProps}
        urlParams={urlParams}
        isFromAccountDropDown={true}
        myCommonTestLabels={myCommonTestLabels}
      />
    );
  }
}

MyPrefrenceContainer.propTypes = {
  labels: PropTypes.shape({}),
  handleComponentChange: PropTypes.func,
  componentProps: PropTypes.shape({}),
  router: PropTypes.shape({
    query: PropTypes.shape({}),
  }),
};

MyPrefrenceContainer.defaultProps = {
  labels: {},
  handleComponentChange: () => {},
  componentProps: {},
  router: {},
};

const withReducer = withDynamicReducer({
  key: 'AddMailingAddressReducer',
  reducer: AddMailingAddressReducer,
});
const withSaga = withDynamicSaga({ key: 'MailingAddressSaga', saga: MailingAddressSaga });

export default compose(withReducer, withSaga, connect())(MyPrefrenceContainer);
